<template>
  <modal
    width="400px"
    speed="fast"
    noOutClose
    noClose
    maskNoClick
    :show="show"
    enter-active-class="fadeIn"
    leave-active-class="fadeOut"
    @update:show="close"
    class="quit-tip"
  >
    <p slot="header">提示</p>
    <div slot="content">
      <p class="text">设备检测尚未完成，退出将会影响考试正常进行，是否确认退出？</p>
    </div>
    <div slot="footer">
      <button class="white-btn" @click="quit">退出</button>
      <button
        class="blue-btn"
        @click="close">继续检测</button>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
export default {
  components: {
    Modal
  },
  data() {
    return {
      show: true
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    quit() {
      this.$emit('quit')
    }
  }
}
</script>

<style lang="scss" scoped>
  /deep/ .modal-head {
    padding: 16px 20px;
    border-bottom: 1px solid #F1F1F1;
  }
  .white-btn {
    @include cancel-btn(96px, 36px, 14px, 4px);
    margin-right: 20px;
    margin-bottom: 10px;
  }
  .blue-btn {
    @include theme-fill-btn(96px, 36px, 14px, 4px);
  }
  .text {
    font-size: 16px;
    margin: 20px 0 0 0;
  }
</style>
